import moment from 'moment';

class LeaveBenefitModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'LeaveBenefitModal';
    $scope.step = 0;

    $scope.annualBenefit = $uibModalInstance.annualBenefit;
    $scope.effectiveDate = moment($uibModalInstance.effectiveDate).toDate();
    $scope.leaveId = $uibModalInstance.leaveId;
    $scope.employeeId = $uibModalInstance.employeeId;

    $scope.override = function() {
      $scope.method = 'override';
      $scope.step = 1;
    };

    $scope.update = function() {
      $scope.method = 'update';
      $scope.step = 1;
    };

    $scope.cancel = function () {
      $uibModalInstance.cancel();
    };

    $scope.opened = {};
    $scope.datePickerOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    $scope.datePickerFormat = 'MMM dd, yyyy';

    $scope.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened[elementOpened] = !$scope.opened[elementOpened];
    };


    $scope.overrideAnnualBenefit = function() {
      let self = this;
      let obj = {
        annualBenefit: $scope.annualBenefit,
        effectiveDate: $scope.effectiveDate
      };


      $http.patch($rootScope.apiHost+"/api/admin/users/"+$scope.employeeId+"/userleave/"+$scope.leaveId, obj, {withCredentials: true}).then(function (success) {
        $uibModalInstance.annualBenefit = $scope.annualBenefit;
        $uibModalInstance.effectiveDate = $scope.effectiveDate;
        $uibModalInstance.success();
      }, function (failure) {
        $scope.errorMessage = failure.message;
      });
    }


    $scope.updateLeaveBenefit = function() {
      let self = this;

      let newBenefit = {
        annualBenefit: $scope.annualBenefit,
        newEffectiveDate: $scope.effectiveDate
      };

      $http.patch($rootScope.apiHost+"/api/admin/users/"+$scope.employeeId+"/userleave/"+$scope.leaveId+"/annualbenefit", newBenefit, {withCredentials: true}).then(function (success) {
        $uibModalInstance.success();
      }, function (failure) {
        console.log(failure);
        $scope.errorMessage = failure.data.message;
      });
    }
  }





}

export default LeaveBenefitModalController;



// WEBPACK FOOTER //
// ./client/common/modals/leaveBenefitModal/leaveBenefitModal.controller.js